<template>
    <div class="botmobile">
        <p> © 2021 All Rights Reserved  <span style="margin-left: 5px;">苏州量子方舟网络科技有限公司</span></p>
        <p> 版权所有 <span class="bottomSpans">
                     <a href="https://beian.miit.gov.cn/" style="">苏ICP备18053448号-2</a>
                </span></p>
    </div>
</template>

<script>
    export default {
        name: "botmobile",
        data() {
            return {}
        },
        mounted() {
        },
        methods: {},
    }
</script>

<style scoped lang='scss'>
    .botmobile {
        width: 100%;
        z-index: 3;
        padding: 5px;
        height: auto;
        box-sizing: border-box;
        position: fixed;
        bottom: 0;
        font-size: 12px;
        display: flex;
        flex-direction: column;
        color: #B3B2B2;
        background: #fff;
        box-shadow: 0px -1px 8px 2px rgba(187, 186, 186, 0.75);
        -webkit-box-shadow: 0px -1px 8px 2px rgba(187, 186, 186, 0.75);
        -moz-box-shadow: 0px -1px 8px 2px rgba(187, 186, 186, 0.75);
        p{
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
        }
        .bottomSpans {
            cursor: pointer;

            a {
                text-decoration: none;
            }

            color: #B3B2B2;

            a:visited, a:link, a:active {
                color: #B3B2B2;
            }

            a:hover {
                color: #4f8aff;
            }
        }
    }
</style>